import styled, { css } from 'styled-components';

import { BUTTON_BASE_RESET_CSS } from '@pkg/components/Sections/Profile/Buttons';
import { styledTypography } from '@pkg/primitives';

export const TABLE_GRID_BASE = css`
    display: grid;
`;

export const TABLE_ITEM_BASE = css`
    border-bottom: 1px solid ${({ theme }) => theme.shades.white[20]};
    overflow-wrap: anywhere;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding: 10px;
    display: grid;
`;

export const UserTableRow = styled.div`
    ${TABLE_GRID_BASE};
    grid-template-columns: repeat(2, 3fr) repeat(2, 2fr) 4fr 5fr;
`;

export const UserTableItem = styled.div`
    ${TABLE_ITEM_BASE};
    align-content: flex-start;
    font-size: 14px;
`;

export const UserTableHeader = styled.div`
    border-bottom: 1px solid ${({ theme }) => theme.shades.white[50]};
    ${TABLE_ITEM_BASE};
    font-weight: bold;
`;

export const PaddedWrapper = styled.div`
    padding: 10px 30px;
`;

export const FLEX_WRAPPER = css`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const ButtonWrapper = styled.div`
    ${FLEX_WRAPPER};
    gap: 10px;
    align-items: flex-end;
`;

export const ControlWrapper = styled.div`
    ${FLEX_WRAPPER};
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 40px 0;
`;

interface Props {
    $expanded: boolean;
}

interface FeatureProps {
    $featureOn?: boolean;
}

export const Expandable = styled.div<Props>`
    display: ${({ $expanded }) => ($expanded ? 'grid' : 'none')};
`;

export const FeatureButton = styled.button<FeatureProps>`
    ${BUTTON_BASE_RESET_CSS};
    ${styledTypography.allianceBase};
    color: ${({ $featureOn }) => ($featureOn ? 'limegreen' : 'crimson')};
    text-transform: capitalize;
    font-size: 15px;
    text-align: left;
    &:hover {
        opacity: 0.8;
    }
`;
export const FeatureGrid = styled.div`
    display: grid;
    gap: 5px;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    width: 100%;
    place-content: flex-start;
    place-items: flex-start;
    padding: 20px 0;
`;

export const TruncatedValue = styled.div<{ $cursor?: 'pointer' | 'copy'; $maxWidth?: number }>`
    ${styledTypography.truncate};
    cursor: ${({ $cursor }) => $cursor ?? 'auto'};
    max-width: ${({ $maxWidth }) => `${$maxWidth}px` ?? '100%'};
`;

export const UserYatAmount = styled.div`
    ${FLEX_WRAPPER};
    strong {
        margin-right: 5px;
    }
    button {
        font-size: 7px;
        letter-spacing: -0.7px;
    }
`;
